import React, { useEffect, useState } from 'react';
import Avatar, { AvatarShape, AvatarSize } from '@/components/cards/Avatar';
import useNftMeta from '@/hooks/useNftMeta';
import useWindowSize from '@/hooks/useWindowSize';

type BidData = {
  Collection: {
    nft_contract_address: string;
  };
  token_id: string;
  alt?: string;
};

type NftAvatarProps = {
  data: BidData;
};

type BidAvatarGroupProps = {
  data: BidData[];
  size?: AvatarSize;
};

const BidAvatarGroup = ({ data }: BidAvatarGroupProps) => {
  const zStack = ['z-30', 'z-20', 'z-10'];
  const windowSize = useWindowSize();
  const [avatarGroupCount, setAvatarGroupCount] = useState(2);

  useEffect(() => {
    setAvatarGroupCount(windowSize.width < 640 ? 2 : 3);
  }, [windowSize.width]);

  return (
    <div className="z-10 flex -space-x-4">
      {data.slice(0, avatarGroupCount).map((item, index) => {
        return (
          <div key={index} className={zStack[index]}>
            <NftAvatar data={item} />
          </div>
        );
      })}
      {data.length > avatarGroupCount ? (
        <div className="relative z-0 bg-clip-border">
          <div className="flex h-[38px] w-[38px] place-content-center items-center rounded-lg bg-white pl-4 text-md text-primary-main md:h-[56px] md:w-[56px] md:pl-0 lg:text-lg">
            <div>+{data.length - avatarGroupCount}</div>
          </div>
        </div>
      ) : undefined}
    </div>
  );
};
export default BidAvatarGroup;

const NftAvatar = ({ data }: NftAvatarProps) => {
  const { nftImage } = useNftMeta({
    collectionAddress: data.Collection.nft_contract_address,
    tokenId: data.token_id,
  });

  return (
    <Avatar
      shape={AvatarShape.square}
      size={AvatarSize.sm}
      alt={data.alt ?? 'avatar'}
      src={nftImage}
    />
  );
};
